import { render, staticRenderFns } from "./RouletteSettingView.vue?vue&type=template&id=4c041d45&"
import script from "./RouletteSettingView.vue?vue&type=script&lang=js&"
export * from "./RouletteSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports